import { globalVariables } from "helper/globalVariables";
import { becomeAJudgeResolver } from "validators/UserValidation";
import { useForm } from "react-hook-form";
import { TextInput } from "shared/Components/textInput";
import { Button } from "shared/Components/button";
import Modal from "shared/Components/modal";
import { useSelector } from "react-redux";
import { useEffect, useCallback, useState } from "react";
import { updateMemberProfileMutation } from "redux/features/memberSlice/memberGql";
import { client } from "helper/apolloConfig";
import { AutoCompleteInput } from "shared/Components/autoComplete";

export function ApplyForJudgeModal({modalRef, setApplied, applied}) {
  const { auth } = useSelector((state) => state);

  const [loading, setLoading] = useState(false);
  
  const TIME_ZONES = [
    "EasternTime",
    "CentralTime",
    "MountainTime",
    "PacificTime",
    "AlaskaTime",
    "Hawaii-AleutianTime",
  ];

  const [timeZone, setTimeZone] = useState('');

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: becomeAJudgeResolver,
  });

  const getMemberProfile = useCallback(async () => {
    if (auth?.memberReducer?.memberDetails) {
      const memberProfile = auth?.memberReducer?.memberDetails;
      setValue("address", memberProfile?.location_address);
      setValue("phoneNumber", memberProfile?.phone_number);
      setValue("distance", memberProfile?.distance_travel);
      setValue("timeZone", memberProfile?.timezone);
      setTimeZone(memberProfile?.timezone);
      if (auth?.memberReducer?.memberDetails?.judgeStatus == "active") {
        setApplied(true);
      }
    }
  }, [auth?.memberReducer?.memberDetails, setValue]);

  useEffect(() => {
    getMemberProfile();
  }, [getMemberProfile]);

  const handleApply = async (data) => {
    let payload = {
      distance_travel: String(data.distance),
      judgeStatus: "active",
      timezone: String(data.timeZone),
    };
    setLoading(true);
    try {
      const result = await client.mutate({
        mutation: updateMemberProfileMutation,
        variables: { data: payload },
      });
      setApplied(true);
      setLoading(false);
    } catch (err) {
      console.log("Err", err);
      setApplied(false);
    }
  };

  return (
    <Modal
      extraClass={`pt-0`}
      headerClass="sticky top-6 left-100 z-50"
      iconPosition="right-0"
      ref={modalRef}
    >
      <div className="p-8 pb-0 md:w-[450px]">
        <p className="text-lg font-semibold text-gray-900">
          Thank you for your interest in becoming a Judge for KSG! Please fill out this form and we will contact you to discuss the Judge Application process and requirements.
        </p>

        <form
          className="flex flex-col gap-3 items-center justify-center mt-4"
          onSubmit={handleSubmit(handleApply)}
        >
          <TextInput
            width="w-full"
            register={register}
            name="address"
            placeholder={globalVariables.enterYourAddress}
            errorMsg={errors.address?.message}
            label={globalVariables.address}
            textTransform="normal-case"
            disabled
          />
          <TextInput
            width="w-full"
            register={register}
            name="phoneNumber"
            placeholder={globalVariables.enterYourPhoneNumber}
            errorMsg={errors.phoneNumber?.message}
            label={globalVariables.phoneNumber}
            disabled
          />
          <TextInput
            width="w-full"
            register={register}
            name="distance"
            placeholder={globalVariables.enterDistanceReady}
            errorMsg={errors.distance?.message}
            label={globalVariables.distanceReadyToTravel}
            disabled={applied}
          />
           <AutoCompleteInput
              options={TIME_ZONES}
              placeholder={globalVariables.timeZone}
              errorMsg={errors.timeZone?.message}
              label={globalVariables.timeZone}
              onSelect={(timeZone) => {
                setValue("timeZone", timeZone, { shouldValidate: true }); 
                setTimeZone(timeZone);
              }}
              defaultOption={timeZone}
              disabled={applied}
            />
          <Button
            disabled={loading}
            onlyDisabled={applied}
            label={applied ? "Applied" : `Apply`}
            width="w-full"
          />
        </form>
      </div>
    </Modal>
  );
}
